// services/product.js
import apiClient from './api';

/**
 * Fetches a list of products from a Salesforce org (generic endpoint).
 * Corresponds to: GET /api/products/:orgId/salesforce
 */
export async function getSalesforceProducts(orgId, filters = null) {
  console.log('[getSalesforceProducts]', orgId, filters);
  const response = await apiClient.get(`/products/${orgId}/salesforce`, { data: { filters } });
  return response.data;
}

/**
 * Fetches all product versions stored in our database for the current tenant.
 * Corresponds to: GET /api/products/database/all
 */
export async function getAllProductsFromDb() {
  const response = await apiClient.get('/products/database/all');
  return response.data;
}

/**
 * Fetches specific product versions from our database for a given org.
 * Corresponds to: GET /api/products/:orgId/database
 */
export async function getProductsFromDb(orgId, products, isDeploy = false) {
  console.log('[getProductsFromDb]', orgId, products, isDeploy);

  const response = await apiClient.post(`/products/${orgId}/database`, {
    productIds: products,
    isDeploy,
  });
  return response.data;
}

/**
 * Fetches only the major versions of products from our database for a given org.
 * Corresponds to: GET /api/products/:orgId/database/major-versions
 */
export async function getMajorVersionsFromDb(orgId, products) {
  console.log('[getMajorVersionsFromDb]', orgId, products);

  const response = await apiClient.post(`/products/${orgId}/database/major-versions`, {
    productIds: products,
  });
  return response.data;
}

/**
 * Compares a Salesforce product object with a database product object.
 * Corresponds to: POST /api/products/compare
 */
export async function compareProducts(sfProduct, databaseProduct, isDeploy) {
  console.log('[compareProducts]', sfProduct, databaseProduct, isDeploy);

  const response = await apiClient.post('/products/compare', {
    sf_product: sfProduct,
    database_product: databaseProduct,
    isDeploy,
  });

  console.log('[compareProducts] response', response.data);

  return response.data;
}

/**
 * Commits products fetched from Salesforce to our internal database.
 * Corresponds to: POST /api/products/:orgId/commit
 */
export async function commitProductsToDatabase(orgId, products) {
  const response = await apiClient.post(`/products/${orgId}/commit`, { products });

  return response.data;
}

/**
 * Deploys product configurations from our database to Salesforce.
 * Corresponds to: POST /api/products/:orgId/deploy
 */
export async function deployProducts(orgId, products) {
  const response = await apiClient.post(`/products/${orgId}/deploy`, { products });
  return response.data.response;
}
